/** Shared Pear bulk conversion status checks (CSV, status bar). */

const FILE_FAILED_STATUSES = new Set([
  'failed',
  'error',
  'cancelled',
  'canceled',
])

const FILE_SUCCESS_STATUSES = new Set([
  'completed',
  'success',
  'done',
  'succeeded',
])

const CONVERSION_BUSY_STATUSES = new Set(['queued', 'processing'])

export function isConversionBusy(conversion) {
  const status = String(conversion?.status ?? '').toLowerCase()
  return CONVERSION_BUSY_STATUSES.has(status)
}

export function isConversionFailed(conversion) {
  const status = String(conversion?.status ?? '').toLowerCase()
  return FILE_FAILED_STATUSES.has(status)
}

export function isConversionSettled(conversion) {
  const status = String(conversion?.status ?? '').toLowerCase()
  return Boolean(status) && !CONVERSION_BUSY_STATUSES.has(status)
}

export function isSuccessfulConversionFile(file) {
  const status = String(file?.status ?? '').toLowerCase()
  if (FILE_FAILED_STATUSES.has(status)) return false
  if (FILE_SUCCESS_STATUSES.has(status)) return true
  const contentId = file?.content_id
  return contentId != null && String(contentId).trim() !== ''
}
